import { useSelector } from 'react-redux'

const useMoney = (func, ...params) => {
    const orderMethod = useSelector(state => state.OrderReducer.orderMethod)
    return func(...params, orderMethod)
}

export default useMoney
